export default "__VITE_ASSET__Csmg4OaE__"